import Typography from '@/common/components/base/typography/Typography';
import { Box } from 'styled-system/jsx';
import { RankCardProps } from '../../types/RankingCard.type';
import { convertPersian } from '../../utils/convertPersian';

const RankingCard = ({
  rank,
  label,
  totalAssessors,
  icon,
  themeColor,
}: RankCardProps) => {
  const isOrange = themeColor === 'orange';
  const isRed = themeColor === 'red';

  const assessorsText = `از ${convertPersian(totalAssessors ?? 0)} ${
    isOrange ? 'نظر' : 'کارشناس'
  }`;

  const themeBorderGradient =
    themeColor === 'purple'
      ? 'linear-gradient(180deg, #D0C2FF -42.94%, #FFFFFF 100%)'
      : themeColor === 'blue'
        ? 'linear-gradient(180deg, #96DEFF -42.94%, #FFFFFF 100%)'
        : themeColor === 'orange'
          ? 'linear-gradient(180deg, #EFB608 -86.84%, #FFFFFF 71.05%)'
          : 'linear-gradient(180deg, #F14A68 -86.84%, #FFFFFF 71.05%)';

  return (
    <Box
      width="100%"
      margin="5px 0px"
      borderRadius="8px"
      padding="1px"
      backgroundImage={themeBorderGradient}
      boxShadow="0px 4px 8px 0px rgba(0, 0, 0, 0.04)"
    >
      <Box
        width="100%"
        padding="12px 12px"
        borderRadius="7px"
        backgroundColor="white"
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          gap="6px"
        >
          <Box display="flex" alignItems="center" gap="10px">
            <Typography textStyle="b1" fontWeight="bold" color="#374151">
              {label}
            </Typography>
          </Box>

          {!isRed && (
            <Typography textStyle="b2" color="#646464">
              {assessorsText}
            </Typography>
          )}
        </Box>

        <Box display="flex" alignItems="flex-start" gap="16px">
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            gap="8px"
          >
            <Box display="flex" alignItems="center" gap="6px">
              <Typography fontSize="16" fontWeight="bold" color="black">
                {isRed
                  ? `${convertPersian(rank ?? 0)} مورد`
                  : `${convertPersian(rank ?? 0)}`}
              </Typography>
            </Box>
          </Box>

          {icon}
        </Box>
      </Box>
    </Box>
  );
};

export default RankingCard;
